import axios from 'axios';
import { DocumentSchemaType } from '../db/schema';
import { API_URL } from '../config/api'; // Импортируем глобальный API_URL

/**
 * Класс для взаимодействия с серверным API
 */
export class ApiClient {
  // Убираем локальную переменную
  // private readonly API_URL = '/api';

  /**
   * Получает документ с сервера по ID
   * @param documentId ID документа
   * @returns Документ с сервера
   */
  async fetchDocument(documentId: string): Promise<{
    content: any;
    serverTimestamp: number;
  }> {
    try {
      const response = await axios.get(`${API_URL}/documents/${documentId}`); // Используем импортированный API_URL
      
      return {
        content: response.data.content,
        serverTimestamp: new Date(response.data.updatedAt).getTime()
      };
    } catch (error) {
      console.error('Ошибка при получении документа с сервера:', error);
      throw new Error('Не удалось получить документ с сервера');
    }
  }

  /**
   * Сохраняет документ на сервере
   * @param documentId ID документа
   * @param content Содержимое документа
   * @returns Результат сохранения с временной меткой сервера
   */
  async saveDocument(documentId: string, content: any): Promise<{
    success: boolean;
    serverTimestamp: number;
  }> {
    try {
      const response = await axios.put(`${API_URL}/documents/${documentId}`, { // Используем импортированный API_URL
        content
      });
      
      return {
        success: true,
        serverTimestamp: new Date(response.data.updatedAt).getTime()
      };
    } catch (error) {
      console.error('Ошибка при сохранении документа на сервере:', error);
      throw new Error('Не удалось сохранить документ на сервере');
    }
  }

  /**
   * Отправляет несинхронизированные документы на сервер
   * через navigator.sendBeacon (используется при закрытии страницы)
   * @param documents Массив документов для синхронизации
   * @returns Успешность отправки
   */
  sendBeaconSync(documents: DocumentSchemaType[]): boolean {
    if (!navigator.sendBeacon) {
      return false;
    }

    try {
      const data = new Blob(
        [JSON.stringify({ documents })],
        { type: 'application/json' }
      );
      
      return navigator.sendBeacon(`${API_URL}/documents/sync-beacon`, data); // Используем импортированный API_URL
    } catch (error) {
      console.error('Ошибка при отправке данных через beacon:', error);
      return false;
    }
  }
}

// Экземпляр API клиента для использования в приложении
export const apiClient = new ApiClient(); 